import { Employee, Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

export const filterEmployees = (employees: Employee[] | null, search: string, locales: Locale[]) => {
    return (employees ?? []).filter(
        employee =>
            employee.fullName.toLowerCase().includes(search.toLowerCase()) ||
            (employee.position &&
                getLocalizedString(locales, employee.position.name)?.toLowerCase().includes(search.toLowerCase()))
    );
};
